<template>
    <Article>
        <template #header>
            <h2>Inspiration &amp; Tributes</h2>
        </template>
        <template #content>
            <div id="post-553" class="clearfix post-553 page type-page status-publish hentry">
                <p>
                    Over the years, there have been many instances where the men of Merrill&rsquo;s
                    Marauders have been honored with poetry or other forms of inspiration. This page
                    has links to some we know about, and more may be added over time.
                </p>
                <p>
                    Links posted here have been added with the permission of the author. You are
                    free to print these poems for your own enjoyment, but please honor the
                    copyright.
                </p>
                <p>
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/Sentinels-of-Freedom.pdf?alt=media"
                        target="_blank"
                    >
                        Sentinels of Freedom
                    </a>
                    by Clif Hyatt (8.5 x 11, vertical, color)
                    <br />
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/Merrills-Marauders.pdf?alt=media"
                        target="_blank"
                    >
                        Merrill&rsquo;s Marauders
                    </a>
                    by Clif Hyatt (8.5 x 11, horizontal, color)
                    <br />
                    <a
                        href="https://firebasestorage.googleapis.com/v0/b/merrills-marauders-pd.appspot.com/o/The-Last-Doughboy.pdf?alt=media"
                        target="_blank"
                    >
                        The Last Doughboy
                    </a>
                    by Clif Hyatt (8.5 x 11, vertical, color)
                </p>
            </div>
        </template>
    </Article>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Article from '@/components/Article/Article.vue';

export default defineComponent({
    name: 'InspirationAndTributes',
    components: { Article }
});
</script>
